// src/hooks/useSsoFlow.ts
import { useCallback } from "react";

import { api } from "../lib/api";
import type { RegistrationLegalConsent } from "../lib/legalConsent";

export type SsoLoginResponse = {
  email: string;
  userId?: string;
  secretKey?: string;
  accessToken?: string;
  refreshToken?: string;
  isNewUser?: boolean;
};

/**
 * SSO ログインのフローを管理するフック。
 *
 * 使い方:
 *   const { startSsoLogin } = useSsoFlow(async (response) => { ... 認証成功後の処理 ... });
 *
 * - startSsoLogin: 任意の SSO プロバイダーのトークンで認証を試みる。
 *   エラーは throw する（呼び出し元でハンドリングすること）。
 */
export function useSsoFlow(onSuccess: (response: SsoLoginResponse) => Promise<void>) {
  const startSsoLogin = useCallback(async (
    idToken: string,
    mode: 'auto' | 'login' | 'register' = 'auto',
    legalConsent?: RegistrationLegalConsent
  ): Promise<void> => {
    const response = await api.googleSsoLogin({ idToken, mode, ...legalConsent });
    await onSuccess(response);
  }, [onSuccess]);

  return {
    startSsoLogin,
  };
}
